import { render, staticRenderFns } from "./SubmitForm.vue?vue&type=template&id=bd44dd36&"
import script from "./SubmitForm.vue?vue&type=script&lang=js&"
export * from "./SubmitForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports